export function isAbsolute(path: string) {
  // regex inspired by https://github.com/sindresorhus/is-absolute-url
  return /^[a-z][a-z0-9+.-]*:|\/\//.test(path);
}
